import authService from "utils/auth";
import { Navigate } from "react-router-dom";
import { storage } from "utils/storage";
import { RoleTypes } from "enum/role-type-enum";

interface PublicRouteProps {
  element: React.FC;
  isRestricted: boolean;
}

const PublicRoute = ({ element: Component, isRestricted, ...rest }: PublicRouteProps) => {
  const user = storage.getUserFromStorage();

  return authService.isLogin() && isRestricted ? (
    <Navigate
      to={
        user.role === RoleTypes.ENUMERATOR
          ? "/enumerator/home"
          : user.role === RoleTypes.RECRUITER
          ? "/recruiter/home"
          : "/"
      }
    />
  ) : (
    <Component {...rest} />
  );
};

export default PublicRoute;
